module.exports = __webpack_public_path__ + "img/money-dollar-box-line.fcd0b31c.svg";